function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5 8l1.5 3h-.7l1.7 3h-1l2 3h-4v4h-2v-4h-3v4h-2v-4H8v4H6v-4H2l2-3H3l1.7-3H4l1.5-3H5l2-5 2 5h-.5l1 2 1-2H10l2-5 2 5h-.5l1 2 1-2H15l2-5 2 5h-.5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationForest = function SvgLocationForest(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationForest;